// extracted by mini-css-extract-plugin
export var button = "status-bar-module--button--6mnLt";
export var content = "status-bar-module--content--c2fHg";
export var error = "status-bar-module--error--hzfN7";
export var holder = "status-bar-module--holder--03wv5";
export var success = "status-bar-module--success--qkVlo";
export var warning = "status-bar-module--warning--qkmz-";